// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompanyLayout_loader__JzrTj {
  height: 100vh;
}

.CompanyLayout_sidebar__o9GV2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 334px;
  max-width: 335px;
  height: 100vh;
  position: sticky;
  min-height: 100%;
  top: 0;
  border-right: 1px solid #E2E2E2;
  padding: 24px;
  overflow-x: hidden;
}
.CompanyLayout_sidebar__list__fpFbf {
  width: 100%;
}
.CompanyLayout_sidebar__back__BqKHf {
  border-radius: 4px;
  padding: 4px 24px 4px 16px;
  background: #F7F7F7;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: auto;
  color: #8E8E93;
  text-decoration: none;
}
.CompanyLayout_sidebar__backIcon__dwwGK {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  width: 16px;
  height: 16px;
}
.CompanyLayout_sidebar__company__vqSr8 {
  display: flex;
  align-items: center;
  margin: 32px 0;
  max-width: 100%;
  text-align: left;
}
.CompanyLayout_sidebar__companyAvatar__oGh6i {
  min-width: 48px;
}
.CompanyLayout_sidebar__logo__JOKdj {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(180deg, #FFFFFF 0%, #F9F9F9 100%);
  border: 1px solid #E5E6EE;
  border-radius: 4px;
}
.CompanyLayout_sidebar__logoImg__rXZz- {
  width: 39px;
  height: 36px;
}
.CompanyLayout_sidebar__logoText__OPj9V {
  font-family: Roboto, serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: #000;
  margin-left: 12px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.CompanyLayout_menuItem__gZFQ8 {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: Roboto, serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
  margin-bottom: 8px;
  padding: 8px 16px;
  cursor: pointer;
  color: #272A36;
  text-decoration: none;
}
.CompanyLayout_menuItem__statuses__aSKEv {
  display: flex;
  margin-left: 32px;
  margin-top: 7px;
}
.CompanyLayout_menuItem__status__9HDEc {
  display: flex;
  align-items: center;
}
.CompanyLayout_menuItem__status__9HDEc:not(:last-of-type) {
  margin-right: 8px;
}
.CompanyLayout_menuItem__statusPending__wnPNt {
  color: #3EBF71;
  margin-left: 4px;
}
.CompanyLayout_menuItem__statusAwait__jW1Kf {
  color: #E59F42;
  margin-left: 4px;
}
.CompanyLayout_menuItem__statusError__RX2ad {
  color: #E23834;
  margin-left: 4px;
}
.CompanyLayout_menuItem__link__oIoZ5 {
  text-decoration: none;
}
.CompanyLayout_menuItem__text__rpO-N {
  display: flex;
  align-items: center;
}
.CompanyLayout_menuItemActive__V84QV {
  border-radius: 12px;
  background-color: #F0F4FE;
  color: #4778EE;
}
.CompanyLayout_menuItem__icon__QQeYr {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 12px;
}
.CompanyLayout_menuItem__gZFQ8:hover, .CompanyLayout_menuItemActive__V84QV {
  color: #4778EE;
}
.CompanyLayout_menuItem__gZFQ8:hover .CompanyLayout_menuItem__icon__QQeYr path, .CompanyLayout_menuItemActive__V84QV .CompanyLayout_menuItem__icon__QQeYr path {
  fill: #4778EE !important;
}
.CompanyLayout_menuItemDisabled__gKK6p {
  color: #c8cbde !important;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  cursor: default;
}
.CompanyLayout_menuItemDisabled__gKK6p:hover .CompanyLayout_menuItem__icon__QQeYr path {
  fill: #c8cbde !important;
}

.CompanyLayout_root__H4NZa {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.CompanyLayout_title__A5hXJ {
  font-family: Roboto, serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0;
  text-align: left;
  margin-bottom: 12px;
}

.CompanyLayout_header__jL1Ee {
  width: 100%;
  height: 64px;
  border-bottom: 1px solid #E2E2E2;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background: #fff;
  justify-content: space-between;
  align-items: center;
  padding-right: 16px;
  display: none;
}
.CompanyLayout_header__menu__oqb0f {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 16px;
  cursor: pointer;
}
.CompanyLayout_header__logoImg__k7Mu4 {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}

.CompanyLayout_company__Kz0Yx {
  display: flex;
  align-items: stretch;
  height: 100%;
  flex-grow: 1;
}
.CompanyLayout_company__main__K25Fq {
  padding: 24px;
  width: 1032px;
  margin: 0 auto;
}
.CompanyLayout_company__dialog__Cc9hR {
  width: 100%;
  background: #FAFBFC;
}
.CompanyLayout_company__notify__V2nz- {
  background: linear-gradient(0deg, #F0F4FE, #F0F4FE), #4778EE;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px;
  margin-bottom: 24px;
  font-family: Roboto, serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
}
.CompanyLayout_company__notifyIcon__ctFj2 {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.CompanyLayout_company__logo__tW8-- {
  padding: 32px 28px 32px 27px;
  border: 1px solid #E5E6EE;
  border-radius: 20px;
  margin-right: 24px;
}
.CompanyLayout_company__logoImg__VgwFO {
  height: 96px;
  width: 105px;
}
.CompanyLayout_company__name__8Vrc5 {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.CompanyLayout_company__nameHead__eSDdx {
  font-family: Roboto, serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0;
  text-align: left;
  color: #272A36;
  margin-bottom: 6px;
}
.CompanyLayout_company__nameValue__rPbr7 {
  font-family: Roboto, serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: 0;
  text-align: left;
  color: #272A36;
}

@media (max-width: 1366px) {
  .CompanyLayout_company__main__K25Fq {
    width: calc(100% - 334px);
  }
}
@media (max-width: 672px) {
  .CompanyLayout_sidebar__o9GV2 {
    display: none;
  }
  .CompanyLayout_header__jL1Ee {
    display: flex;
  }
  .CompanyLayout_company__main__K25Fq {
    margin-top: 64px;
    padding: 15px 12px;
    width: 100%;
  }
  .CompanyLayout_sidebar_showMobile__SJicg {
    display: flex;
    padding: 16px;
    position: fixed;
    background: #fff;
    z-index: 100;
    width: 100%;
    max-width: none;
    margin-top: 64px;
    height: auto;
  }
  .CompanyLayout_sidebar__back__BqKHf {
    margin-bottom: 8px;
  }
}
@media (max-width: 600px) {
  .CompanyLayout_sidebar_showMobile__SJicg {
    display: flex;
    padding: 16px;
    position: fixed;
    background: #fff;
    z-index: 100;
    width: 100%;
    max-width: none;
    margin-top: 63px;
    height: auto;
    min-width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/CompanyLayout/CompanyLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,+BAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;AACJ;AAEE;EACE,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAII;EACE,eAAA;AAFN;AAME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,yBAAA;EACA,kBAAA;AAJJ;AAMI;EACE,WAAA;EACA,YAAA;AAJN;AAOI;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;EACA,oBAAA;AALN;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AAPF;AAQE;EACE,aAAA;EACA,iBAAA;EACA,eAAA;AANJ;AAQE;EACE,aAAA;EACA,mBAAA;AANJ;AAOI;EACE,iBAAA;AALN;AAOI;EACE,cAAA;EACA,gBAAA;AALN;AAOI;EACE,cAAA;EACA,gBAAA;AALN;AAOI;EACE,cAAA;EACA,gBAAA;AALN;AAQE;EACE,qBAAA;AANJ;AAQE;EACE,aAAA;EACA,mBAAA;AANJ;AASE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AARJ;AAWE;EACE,cAAA;AATJ;AAWI;EACE,wBAAA;AATN;AAaE;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAXJ;AAaI;EACE,wBAAA;AAXN;;AAgBA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AAbF;AAeE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AAbJ;AAgBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;AAfF;AAiBE;EACE,aAAA;EACA,aAAA;EACA,cAAA;AAfJ;AAkBE;EACE,WAAA;EACA,mBAAA;AAhBJ;AAmBE;EACE,4DAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAjBJ;AAmBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAjBN;AAqBE;EACE,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAnBJ;AAqBI;EACE,YAAA;EACA,YAAA;AAnBN;AAuBE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AArBJ;AAuBI;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AArBN;AAwBI;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAtBN;;AA2BA;EACE;IACE,yBAAA;EAxBF;AACF;AA2BA;EACE;IACE,aAAA;EAzBF;EA2BA;IACE,aAAA;EAzBF;EA2BA;IACE,gBAAA;IACA,kBAAA;IACA,WAAA;EAzBF;EA2BA;IACE,aAAA;IACA,aAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;EAzBF;EA2BA;IACE,kBAAA;EAzBF;AACF;AA6BA;EACE;IACE,aAAA;IACA,aAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;EA3BF;AACF","sourcesContent":[".loader {\n  height: 100vh;\n}\n\n.sidebar {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 334px;\n  max-width: 335px;\n  height: 100vh;\n  position: sticky;\n  min-height: 100%;\n  top: 0;\n  border-right: 1px solid #E2E2E2;\n  padding: 24px;\n  overflow-x: hidden;\n\n  &__list {\n    width: 100%;\n  }\n\n  &__back {\n    border-radius: 4px;\n    padding: 4px 24px 4px 16px;\n    background: #F7F7F7;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    width: auto;\n    color: #8E8E93;\n    text-decoration: none;\n\n    &Icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-right: 12px;\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  &__company {\n    display: flex;\n    align-items: center;\n    margin: 32px 0;\n    max-width: 100%;\n    text-align: left;\n\n    &Avatar {\n      min-width: 48px;\n    }\n  }\n\n  &__logo {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n    background: linear-gradient(180deg, #FFFFFF 0%, #F9F9F9 100%);\n    border: 1px solid #E5E6EE;\n    border-radius: 4px;\n\n    &Img {\n      width: 39px;\n      height: 36px;\n    }\n\n    &Text {\n      font-family: Roboto, serif;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 16px;\n      text-align: left;\n      color: #000;\n      margin-left: 12px;\n      word-break: break-all;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      display: -webkit-box;\n    }\n  }\n}\n\n.menuItem {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  font-family: Roboto, serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: 0;\n  text-align: left;\n  margin-bottom: 8px;\n  padding: 8px 16px;\n  cursor: pointer;\n  color: #272A36;\n  text-decoration: none;\n  &__statuses {\n    display: flex;\n    margin-left: 32px;\n    margin-top: 7px;\n  }\n  &__status {\n    display: flex;\n    align-items: center;\n    &:not(:last-of-type) {\n      margin-right: 8px;\n    }\n    &Pending {\n      color: #3EBF71;\n      margin-left: 4px;\n    }\n    &Await {\n      color: #E59F42;\n      margin-left: 4px;\n    }\n    &Error {\n      color: #E23834;\n      margin-left: 4px;\n    }\n  }\n  &__link {\n    text-decoration: none;\n  }\n  &__text {\n    display: flex;\n    align-items: center;\n  }\n\n  &Active {\n    border-radius: 12px;\n    background-color: #F0F4FE;\n    color: #4778EE;\n  }\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    margin-right: 12px;\n  }\n\n  &:hover, &Active {\n    color: #4778EE;\n\n    .menuItem__icon path {\n      fill: #4778EE !important;\n    }\n  }\n\n  &Disabled {\n    color: #c8cbde !important;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    cursor: default;\n\n    &:hover .menuItem__icon path {\n      fill: #c8cbde !important;\n    }\n  }\n}\n\n.root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  font-family: Roboto, serif;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0;\n  text-align: left;\n  margin-bottom: 12px;\n}\n\n.header {\n  width: 100%;\n  height: 64px;\n  border-bottom: 1px solid #E2E2E2;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  background: #fff;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 16px;\n  display: none;\n\n  &__menu {\n    width: 64px;\n    height: 64px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding-left: 16px;\n    cursor: pointer;\n  }\n\n  &__logoImg {\n    width: 32px;\n    height: 32px;\n    border-radius: 4px;\n  }\n}\n\n.company {\n  display: flex;\n  align-items: stretch;\n  height: 100%;\n  flex-grow: 1;\n\n  &__main {\n    padding: 24px;\n    width: 984px + 48px;\n    margin: 0 auto;\n  }\n\n  &__dialog {\n    width: 100%;\n    background: #FAFBFC;\n  }\n\n  &__notify {\n    background: linear-gradient(0deg, #F0F4FE, #F0F4FE), #4778EE;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 16px;\n    margin-bottom: 24px;\n    font-family: Roboto, serif;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0;\n    text-align: left;\n\n    &Icon {\n      width: 20px;\n      height: 20px;\n      margin-right: 8px;\n    }\n  }\n\n  &__logo {\n    padding: 32px 28px 32px 27px;\n    border: 1px solid #E5E6EE;\n    border-radius: 20px;\n    margin-right: 24px;\n\n    &Img {\n      height: 96px;\n      width: 105px;\n    }\n  }\n\n  &__name {\n    display: flex;\n    align-items: center;\n    margin-bottom: 24px;\n\n    &Head {\n      font-family: Roboto, serif;\n      font-size: 12px;\n      font-weight: 400;\n      line-height: 14px;\n      letter-spacing: 0;\n      text-align: left;\n      color: #272A36;\n      margin-bottom: 6px;\n    }\n\n    &Value {\n      font-family: Roboto, serif;\n      font-size: 20px;\n      font-weight: 500;\n      line-height: 23px;\n      letter-spacing: 0;\n      text-align: left;\n      color: #272A36;\n    }\n  }\n}\n\n@media (max-width: 1366px) {\n  .company__main {\n    width: calc(100% - 334px);\n  }\n}\n\n@media (max-width: 672px) {\n  .sidebar {\n    display: none;\n  }\n  .header {\n    display: flex;\n  }\n  .company__main {\n    margin-top: 64px;\n    padding: 15px 12px;\n    width: 100%;\n  }\n  .sidebar_showMobile {\n    display: flex;\n    padding: 16px;\n    position: fixed;\n    background: #fff;\n    z-index: 100;\n    width: 100%;\n    max-width: none;\n    margin-top: 64px;\n    height: auto;\n  }\n  .sidebar__back {\n    margin-bottom: 8px;\n  }\n}\n\n\n@media (max-width: 600px) {\n  .sidebar_showMobile {\n    display: flex;\n    padding: 16px;\n    position: fixed;\n    background: #fff;\n    z-index: 100;\n    width: 100%;\n    max-width: none;\n    margin-top: 63px;\n    height: auto;\n    min-width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `CompanyLayout_loader__JzrTj`,
	"sidebar": `CompanyLayout_sidebar__o9GV2`,
	"sidebar__list": `CompanyLayout_sidebar__list__fpFbf`,
	"sidebar__back": `CompanyLayout_sidebar__back__BqKHf`,
	"sidebar__backIcon": `CompanyLayout_sidebar__backIcon__dwwGK`,
	"sidebar__company": `CompanyLayout_sidebar__company__vqSr8`,
	"sidebar__companyAvatar": `CompanyLayout_sidebar__companyAvatar__oGh6i`,
	"sidebar__logo": `CompanyLayout_sidebar__logo__JOKdj`,
	"sidebar__logoImg": `CompanyLayout_sidebar__logoImg__rXZz-`,
	"sidebar__logoText": `CompanyLayout_sidebar__logoText__OPj9V`,
	"menuItem": `CompanyLayout_menuItem__gZFQ8`,
	"menuItem__statuses": `CompanyLayout_menuItem__statuses__aSKEv`,
	"menuItem__status": `CompanyLayout_menuItem__status__9HDEc`,
	"menuItem__statusPending": `CompanyLayout_menuItem__statusPending__wnPNt`,
	"menuItem__statusAwait": `CompanyLayout_menuItem__statusAwait__jW1Kf`,
	"menuItem__statusError": `CompanyLayout_menuItem__statusError__RX2ad`,
	"menuItem__link": `CompanyLayout_menuItem__link__oIoZ5`,
	"menuItem__text": `CompanyLayout_menuItem__text__rpO-N`,
	"menuItemActive": `CompanyLayout_menuItemActive__V84QV`,
	"menuItem__icon": `CompanyLayout_menuItem__icon__QQeYr`,
	"menuItemDisabled": `CompanyLayout_menuItemDisabled__gKK6p`,
	"root": `CompanyLayout_root__H4NZa`,
	"title": `CompanyLayout_title__A5hXJ`,
	"header": `CompanyLayout_header__jL1Ee`,
	"header__menu": `CompanyLayout_header__menu__oqb0f`,
	"header__logoImg": `CompanyLayout_header__logoImg__k7Mu4`,
	"company": `CompanyLayout_company__Kz0Yx`,
	"company__main": `CompanyLayout_company__main__K25Fq`,
	"company__dialog": `CompanyLayout_company__dialog__Cc9hR`,
	"company__notify": `CompanyLayout_company__notify__V2nz-`,
	"company__notifyIcon": `CompanyLayout_company__notifyIcon__ctFj2`,
	"company__logo": `CompanyLayout_company__logo__tW8--`,
	"company__logoImg": `CompanyLayout_company__logoImg__VgwFO`,
	"company__name": `CompanyLayout_company__name__8Vrc5`,
	"company__nameHead": `CompanyLayout_company__nameHead__eSDdx`,
	"company__nameValue": `CompanyLayout_company__nameValue__rPbr7`,
	"sidebar_showMobile": `CompanyLayout_sidebar_showMobile__SJicg`
};
export default ___CSS_LOADER_EXPORT___;
